export const names = {
    ANALISI_DATI: 'analisi-dati',
    CENTRALINA: 'centralina',
    DSS: 'dss',
    GELATA: 'gelata',
    IRRIGAZIONE: 'irrigazione',
    MAGICO: 'magico',
    MANUTENZIONE: 'manutenzione',
    MEDIE: 'medie',
    // colture
    AGRUMI: 'agrumi',
    AGRUMI_OIDIO: 'agrumi-oidio',
    GRANO: 'grano',
    GRANO_SEPTORIA: 'grano-septoria',
    MELO: 'melo',
    MELO_TICCHIOLATURA: 'melo-ticchiolatura',
    OLIVO: 'olivo',
    OLIVO_CICLOCONIO: 'olivo-cicloconio',
    OLIVO_LEBBRA: 'olivo-lebbra',
    OLIVO_ROGNA: 'olivo-rogna',
    VITE: 'vite',
    VITE_BOTRITE: 'vite-botrite',
    VITE_OIDIO: 'vite-oidio',
    VITE_PERONOSPORA: 'vite-peronospora',
}

const topics = [
    {
        name: names.MAGICO,
    },
    {
        name: names.ANALISI_DATI,
    },
    {
        name: names.MEDIE,
    },
    {
        name: names.GELATA,
    },
    {
        name: names.IRRIGAZIONE,
    },
    {
        name: names.DSS,
    },
    {
        name: names.CENTRALINA,
    },
    {
        name: names.MANUTENZIONE,
    },
    // agrumi
    {
        name: names.AGRUMI,
        next: names.AGRUMI_OIDIO,
    },
    {
        name: names.AGRUMI_OIDIO,
        prev: names.AGRUMI,
    },
    // grano
    {
        name: names.GRANO,
        next: names.GRANO_SEPTORIA,
    },
    {
        name: names.GRANO_SEPTORIA,
        prev: names.GRANO,
    },
    // vite
    {
        name: names.VITE,
        next: names.VITE_PERONOSPORA,
    },
    {
        name: names.VITE_PERONOSPORA,
        prev: names.VITE,
        next: names.VITE_OIDIO,
    },
    {
        name: names.VITE_OIDIO,
        prev: names.VITE_PERONOSPORA,
        next: names.VITE_BOTRITE,
    },
    {
        name: names.VITE_BOTRITE,
        prev: names.VITE_OIDIO,
    },
    // olivo
    {
        name: names.OLIVO,
        next: names.OLIVO_CICLOCONIO,
    },
    {
        name: names.OLIVO_CICLOCONIO,
        prev: names.OLIVO,
        next: names.OLIVO_LEBBRA,
    },
    {
        name: names.OLIVO_LEBBRA,
        prev: names.OLIVO_CICLOCONIO,
        next: names.OLIVO_ROGNA,
    },
    {
        name: names.OLIVO_ROGNA,
        prev: names.OLIVO_LEBBRA,
    },
    // melo
    {
        name: names.MELO,
        next: names.MELO_TICCHIOLATURA,
    },
    {
        name: names.MELO_TICCHIOLATURA,
        prev: names.MELO,
    },
]

export default topics